<template>
  <div class="contentdetail" v-if="isShowSubmitPage">
    <div class="content-container">
      <div class="warp" :style="{ height: isOpen ? '200px' : '40px' }">
        <p class="text" :class="isOpen ? '' : 'clamp'">
          审核状态：
          <span>{{ reviewInfo.reviewStatus === null ? '未提交' : state }}</span>
          <template v-if="reviewInfo.reviewStatus > 0">审核意见：{{ reviewInfo.reviewRemark }}</template>
          <span v-if="reviewInfo.payFlag !== null">
            缴费状态：
            <span>{{ reviewInfo.payFlag == '0' ? '未缴费' : '已缴费' }}</span>
          </span>
        </p>
        <span class="butn" v-if="reviewInfo.reviewStatus == '2'" @click="isOpen = !isOpen">展开</span>
      </div>

      <div class="cl">
        <div class="title text-center">{{ reviewInfo.title }}</div>
        <div class="desc" v-html="reviewInfo.content"></div>
      </div>
      <div class="studentinfomation"></div>
    </div>
    <div class="upfile">
      <div>
        <p style="font-weight: 600; padding: 12px 0">提交材料</p>

        <a-form :model="formData" ref="formRef" style="padding-top: 12px">
          <a-row :gutter="[24, 24]">
            <a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 8 }" name="certNo" :rules="[{ required: true, message: '证书类型不能为空' }]">
              <template #label>
                <span>
                  证书类型
                  <span style="color: #ff4d4f">*</span>
                </span>
              </template>
              <j-dict-select-tag type="select" v-model="formData.certType" dictCode="degree_cert_type" placeholder="请选择" />
            </a-form-item>
            <div v-if="showField">
              <a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 8 }" name="certNo" :rules="[{ required: true, message: '输入不能为空' }]">
                <template #label>
                  <span>
                    证书成绩单编号
                    <span style="color: #ff4d4f">*</span>
                  </span>
                </template>
                <a-input v-model="formData.certNo" placeholder="请输入" allowClear />
              </a-form-item>

              <a-form-item :label-col="{ span: 8 }" :wrapper-col="{ span: 8 }" name="certScore" :rules="[{ required: true, message: '输入不能为空' }]">
                <template #label>
                  <span>
                    证书成绩
                    <span style="color: #ff4d4f">*</span>
                  </span>
                </template>
                <a-input v-model="formData.certScore" placeholder="请输入" allowClear />
              </a-form-item>
            </div>
          </a-row>
        </a-form>
      </div>
      <div class="margin-bottom-20" style="clear: both">
        <!--        <span style="font-weight: 600">已提交文件</span>-->
        <div style="margin-top: 16px">
          <a-row class="docList" :gutter="[24, 24]">
            <a-col :span="8" v-if="reviewInfo.certUrl">
              <div class="filestyle">
                <a :href="reviewInfo.certUrl" target="_blank">{{ reviewInfo.certUrl.split('/').pop() }}</a>
              </div>
            </a-col>

            <a-col :span="8" v-if="reviewInfo.certUrl2">
              <div class="filestyle">
                <a :href="reviewInfo.certUrl2" target="_blank">{{ reviewInfo.certUrl2.split('/').pop() }}</a>
              </div>
            </a-col>
          </a-row>
        </div>

        <div class="uploadarea">
          <docUpload required :info="uploadItemDefault" @change="onFileChange" @remove="onFileRemove" />
        </div>
      </div>
    </div>

    <div>
      <div v-if="reviewInfo.reviewStatus == '1'" style="margin: 0 auto; width: 100px">
        <a-button type="primary" shape="round" class="btn" @click="gotoPay">去缴费</a-button>
      </div>
      <div v-else style="margin: 0 auto; width: 100px">
        <a-button type="primary" shape="round" class="btn" :loading="loading" @click="handleSubmit">全部提交</a-button>
      </div>
    </div>
  </div>

  <div v-else style="margin-top: 100px; color: red; font-size: 20px;">
    <div style="width: 90%;margin: 0 auto;line-height: 2; text-indent: 2em;" v-html="isShowSubmitContext"></div>
  </div>
</template>

<script>
import docUpload from './docListUpload';

export default {
  name: 'DegreeInfo',
  props: {},
  components: {
    docUpload,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      formData: {
        certType: '',
        certNo: '',
        certScore: '',
      },
      showField: false,
      delFileIds: [],
      fileList: [],
      loading: false,
      isOpen: false,
      reviewInfo: {},
      formRef: null,
      isShowSubmitPage: false,
      isShowSubmitContext: '',
      params: {},
      url: '',
    };
  },
  computed: {
    state() {
      const statusEnum = {
        0: '待审核',
        1: '审核通过',
        2: '审核驳回',
      };
      return statusEnum[this.reviewInfo.reviewStatus];
    },
    uploadItemDefault() {
      return {
        isRequire: true,
        tips: '最多上传2张证件图片,每张≤10MB,原件拍摄,清晰无遮挡',
        fileTitle: '文件上传',
        isInput: 0,
        fileSize: 10,
        fileNumber: 2,
        fileList: this.reviewInfo.docList || [],
        fileType: 'image/jpeg,image/png,image/jpg',
      };
    },
    timeState() {
      // 将字符串日期转换为Date对象
      const startTime = new Date(this.reviewInfo.beginTime);
      const endingTime = new Date(this.reviewInfo.endTime);
      const currentTime = new Date();

      // 比较时间
      if (currentTime >= startTime && currentTime <= endingTime) {
        return '进行中';
      } else if (currentTime < startTime) {
        return '未开始';
      } else {
        return '已结束';
      }
    },
  },
  created() {
    this.getDetailInfo('');
  },
  methods: {
    // 去支付
    gotoPay() {
      this.url = null;
      this.axios.get(`/biz/degree/toPay?detailId=${this.reviewInfo.id}`).then(res => {
        if (res.code === 200) {
          window.open(res.result.url, '_blank');
        }
      });
    },
    getDetailInfo(id) {
      this.axios
        .get(`/biz/degree/getApplyDetail?degreeId=${id}`)
        .then(res => {
          if (res.code === 200 && res.result.checkFlag) {
            this.reviewInfo = res.result;
            this.showField = this.reviewInfo.showField;
            this.formData = {
              certType: this.reviewInfo.certType,
              certScore: this.reviewInfo.certScore,
              certNo: this.reviewInfo.certNo,
            };
            this.isShowSubmitPage = res.result.checkFlag;
          } else {
            this.isShowSubmitPage = res.result.checkFlag;
            this.isShowSubmitContext = res.result.checkMsg;
            this.showField = res.result.showField;
          }
        })
        .catch(err => {});
    },
    backHistory() {
      this.$router.go(-1); // 返回上一层
    },
    downloadDoc(url, name) {
      this.axios
        .get(url, {
          responseType: 'blob',
        })
        .then(res => {
          const url = window.URL.createObjectURL(res);
          const el = document.createElement('a');
          el.setAttribute('href', url);
          el.setAttribute('download', name);
          el.style.display = 'none';
          document.body.appendChild(el);
          el.click();
          document.body.removeChild(el);
        })
        .catch(err => {});
    },
    handleSubmit() {
      if (this.showField) {
        if (!this.formData.certType) {
          this.$message.error('证书类型不能为空!');
          return false;
        }
        if (!this.formData.certNo) {
          this.$message.error('证书成绩单编号不能为空!');
          return false;
        }

        if (!this.formData.certScore) {
          this.$message.error('证书成绩不能为空!');
          return false;
        }
      }
      if (this.fileList.length === 0) {
        this.$message.error('请添加上传附件');
        return false;
      }
      this.submit();
    },
    submit() {
      let params = {
        degreeId: this.reviewInfo.degreeId,
        certUrl: this.fileList.length > 0 && this.fileList[0] ? this.fileList[0].docUrl : '',
        certUrl2: this.fileList.length > 1 && this.fileList[1] ? this.fileList[1].docUrl : '',
        ...this.formData,
      };
      this.loading = true;
      this.axios
        .post('/biz/degree/submitApply', params)
        .then(res => {
          if (res.success) {
            this.$message.success(res.result, 1000);
            setTimeout(() => {
              this.$router.go(0);
            }, 500);
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onFileChange({ file, configId }) {
      this.fileList.push({
        uid: file.uid,
        docUrl: file.url,
        id: file.id,
        docName: file.name,
        fileSize: file.size,
        configId,
        remark: file.remark,
      });
    },
    onFileRemove({ id, uid }) {
      const index = this.fileList.findIndex(item => item.uid === uid);
      this.fileList.splice(index, 1);
      if (id) this.delFileIds.push(id);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';

.content-container {
  background-color: #FFFFFF;
}

.upfile {
  background-color: #FFFFFF;
  margin-top: 20px;
  padding: 28px;
}

.title {
  font-size: 24px;
  margin-top: 30px;
}

.author {
  font-size: 13px;
  color: #999;
}

.cl {
  clear: both;
  padding: 28px;
}

.desc {
  line-height: 30px;
  color: $fontGray;
  text-indent: 2em;
  padding-top: 20px;
}

.contentdetail {
  margin-bottom: 20px;
}

.text {
  font-size: 14px;
  text-align: justify;
  line-height: 1.5;
  float: left;
  line-height: 24px;
}

.text span {
  color: #fc484e;
  margin-right: 10px;
}

.warp {
  background-color: #fefaed;
  line-height: 30px;
  display: inline-block;
  position: relative;
  padding: 10px 20px;
  padding-right: 60px;
  width: 100%;
  transition: height 0.3s;
}

.clamp {
  padding-right: 60px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.butn {
  position: absolute;
  right: 20px;
  top: 8px;
  color: #2caf7a;
  cursor: pointer;
}

.docList {
  display: flex;
  flex-wrap: wrap;
}

.studentinfomation {
  background-color: #FFF;
  width: 100%;
  display: inline-block;
  padding: 28px;
  padding-top: 0px;
}

.filestyle {
  border-radius: 10px;
  border: #eef1f1 solid 1px;
  padding: 20px;
  width: 100%;
  height: 100%;
  display: inline-block;
  cursor: pointer;
  // margin-right 20px
  // margin-top 20px
}

.defaultcss {
  background: url('../../../assets/images/defaulticon.png') no-repeat left center;
  padding-left: 46px;
  float: left;
  height: 30px;
}

.pdfcss {
  background-image: url('../../../assets/images/pdficon.png');
}

.progressbar {
  width: 100%;
  clear: both;
  padding-top: 10px;
}

.filegrey {
  font-size: 12px;
  color: #b2b2b2;
  line-height: 26px;
}

.filestyle {
  span {
    display: block;
  }
}

.downicon {
  float: right;
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.doccss {
  background-image: url('../../../assets/images/docicon.png');
}

.xlscss {
  background-image: url('../../../assets/images/xlsicon.png');
}

.uploadarea {
  margin-top: 20px;
  background-color: #fbfcfc;
}

.uploadicon {
  background: url('../../../assets/images/uploadicon.png') no-repeat left center;
  padding-left: 26px;
}

.btn {
  background-color: $bgColor;
  border: $bgColor solid 1px;
  margin-right: 14px;
  width: 100px;
}

.progressbar {
  width: 100%;
  clear: both;
  padding-top: 10px;
}
</style>
<style lang="css" scoped>
.desc >>> strong {
  font-weight: bold;
}
.ant-form-item {
  margin-bottom: 0;
}
.ant-form-inline .ant-form-item-with-help {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/DegreeInfo.vue